import React, { FormEvent, useCallback, useState } from "react"
import { SingleLineTextInput, Button } from "dash-styled"
import { failMessage } from "../../../../Actions/Client/MessagesActions"
import { getSignupError } from "../../../../Helpers/Functions/error"
import { useDispatch } from "react-redux"
import {
    userConfirmSignUp,
    userResendSignUp
} from "../../../../Actions/Auth/AuthActions"
import { useInput } from "../../../../Hooks/useInput"
import { useBoolean } from "../../../../Hooks/useBoolean"

export interface FormData {
    verificationCode: number
}

interface SignupConfirmFormProps {
    testId?: string
    submitLabel?: string
    label?: string
    errorText?: string
    squashSuccessMessage: boolean
    onSuccess?: () => void
    email: string
}

export const SignupConfirmForm = ({
    submitLabel = "Get started",
    label = "Verification code",
    testId = "signup-confirm-form",
    errorText = "",
    squashSuccessMessage,
    onSuccess,
    email
}: SignupConfirmFormProps) => {
    const dispatch = useDispatch()
    const verificationCode = useInput("", false)
    const [error, setError] = useState<string>(errorText)
    const [canResend, , disableResend] = useBoolean(true)
    const handleSubmit = useCallback(
        async (e?: FormEvent) => {
            e?.preventDefault()
            if (verificationCode.value !== undefined) {
                try {
                    await dispatch(
                        userConfirmSignUp(
                            email,
                            String(verificationCode.value),
                            squashSuccessMessage
                        )
                    )
                    onSuccess?.()
                } catch (e) {
                    const signupError = getSignupError(e)
                    if (signupError.displayType === "toast") {
                        dispatch(failMessage(signupError.message, e))
                        setError("")
                    } else {
                        setError(signupError.message)
                    }
                }
            }
        },
        [
            verificationCode.value,
            dispatch,
            email,
            squashSuccessMessage,
            onSuccess
        ]
    )

    const handleResendCode = useCallback(
        async (e?: FormEvent) => {
            e?.preventDefault()
            await dispatch(userResendSignUp(email))
            disableResend()
        },
        [disableResend, dispatch, email]
    )

    return (
        <form
            onSubmit={handleSubmit}
            data-testid={testId}
            className="flex flex-col items-stretch px-4"
        >
            <SingleLineTextInput
                name="verificationCode"
                type="text"
                label={label}
                value={String(verificationCode.value ?? "")}
                onChange={verificationCode.onChange}
                errorText={error}
                placeholder="123456"
                className="pb-4"
                testId="verification-input"
                required={true}
            />

            <div className="flex">
                <Button
                    type="button"
                    onClick={handleResendCode}
                    color="plain"
                    disabled={!canResend}
                    className="mt-4 mr-2 w-48"
                >
                    Resend code
                </Button>
                <Button
                    type="submit"
                    className="mt-4 w-64 mx-auto"
                    testId="verification-submit-button"
                >
                    {submitLabel}
                </Button>{" "}
            </div>
        </form>
    )
}
